import { call, put, takeLatest } from 'redux-saga/effects'
import { types, actions } from '../modules/UserCards'
import { UserCardsAPIs } from 'api'
import { ResponseErrorHandler } from 'utils'


const { 
    UserCardGetAPI,
    UserCardRemoveAPI,
  
    FunPointTokenGetAPI,
    FunPointCardAddAPI,
    // FunPointCardRemoveAPI,

    TapPayCardAddAPI,
    // TapPayCardRemoveAPI,
} = UserCardsAPIs;

function* watchUserCardGetRequest() {
    yield takeLatest(types.USER_CARD_GET_REQUEST, userCardGetFlow);
}

function* userCardGetFlow(action) {
    try {
        const response = yield call(UserCardGetAPI);
        const responseData = response.data;
        
        if (responseData.status === 'success') {
            yield put(actions.getUserCardCompleted(responseData.data));
        } else {
            ResponseErrorHandler(action.type, responseData.error);

            yield put(actions.getUserCardFailed(responseData.error));
        }
    } catch(error) {
        ResponseErrorHandler(action.type, error);

        yield put(actions.getUserCardFailed(error));
    }
}

function* watchUserCardRemoveRequest() {
    yield takeLatest(types.USER_CARD_REMOVE_REQUEST, userCardRemoveFlow);
}

function* userCardRemoveFlow(action) {
    try {
        const response = yield call(UserCardRemoveAPI);
        const responseData = response.data;

        if (responseData.status === 'success') {
            yield put(actions.removeUserCardCompleted());
        } else {
            ResponseErrorHandler(action.type, responseData.error);

            yield put(actions.removeUserCardFailed(responseData.error));
        }
    } catch(error) {
        ResponseErrorHandler(action.type, error);

        yield put(actions.removeUserCardFailed(error));
    }
}

// FunPoint
function* watchFunPointTokenGetRequest() {
    yield takeLatest(types.FUNPOINT_TOKEN_GET_REQUEST, funpointTokenGetFlow);
}

function* funpointTokenGetFlow(action) {
    try {
        const response = yield call(FunPointTokenGetAPI, action.data);
        const responseData = response.data;

        if (responseData.status === 'success') {
            yield put(actions.getFunPointTokenCompleted(responseData.data));
        } else {
            ResponseErrorHandler(action.type, responseData.error);

            yield put(actions.getFunPointTokenFailed(responseData.error));
        }
    } catch(error) {
        ResponseErrorHandler(action.type, error);

        yield put(actions.getFunPointTokenFailed(error));
    }
}

function* watchFunPointCardAddRequest() {
    yield takeLatest(types.FUNPOINT_CARD_ADD_REQUEST, funpointCardAddFlow);
}

function* funpointCardAddFlow(action) {
    try {
        const response = yield call(FunPointCardAddAPI, action.data);
        const responseData = response.data;

        if (responseData.status === 'success') {
            yield put(actions.addFunPointCardCompleted(responseData.data));
        } else {
            ResponseErrorHandler(action.type, responseData.error);

            yield put(actions.addFunPointCardFailed(responseData.error));
        }
    } catch(error) {
        ResponseErrorHandler(action.type, error);

        yield put(actions.addCardFailed(error));
    }
}

// function* watchFunPointCardRemoveRequest() {
//     yield takeLatest(types.FUNPOINT_CARD_REMOVE_REQUEST, funpointCardRemoveFlow);
// }

// function* funpointCardRemoveFlow(action) {
//     try {
//         const response = yield call(FunPointCardRemoveAPI, action.data);
//         const responseData = response.data;

//         if (responseData.status === 'success') {
//             yield put(actions.removeFunPointCardCompleted());
//         } else {
//             ResponseErrorHandler(action.type, responseData.error);

//             yield put(actions.removeFunPointCardFailed(responseData.error));
//         }
//     } catch(error) {
//         ResponseErrorHandler(action.type, error);

//         yield put(actions.removeFunPointCardFailed(error));
//     }
// }

// TapPay
function* watchTapPayCardAddRequest() {
    yield takeLatest(types.TAPPAY_CARD_ADD_REQUEST, tapPayCardAddFlow);
}

function* tapPayCardAddFlow(action) {
    try {
        const response = yield call(TapPayCardAddAPI, action.data);
        const responseData = response.data;

        if (responseData.status === 'success') {
            yield put(actions.addTapPayCardCompleted(responseData.data));
        } else {
            ResponseErrorHandler(action.type, responseData.error);

            yield put(actions.addTapPayCardFailed(responseData.error));
        }
    } catch(error) {
        ResponseErrorHandler(action.type, error);

        yield put(actions.addTapPayCardFailed(error));
    }
}

// function* watchTapPayCardRemoveRequest() {
//     yield takeLatest(types.TAPPAY_CARD_REMOVE_REQUEST, tapPayCardRemoveFlow);
// }

// function* tapPayCardRemoveFlow(action) {
//     try {
//         const response = yield call(TapPayCardRemoveAPI, action.data);
//         const responseData = response.data;

//         if (responseData.status === 'success') {
//             yield put(actions.removeTapPayCardCompleted());
//         } else {
//             ResponseErrorHandler(action.type, responseData.error);

//             yield put(actions.removeTapPayCardFailed(responseData.error));
//         }
//     } catch(error) {
//         ResponseErrorHandler(action.type, error);

//         yield put(actions.removeTapPayCardFailed(error));
//     }
// }


export default [
    watchUserCardGetRequest(),
    watchUserCardRemoveRequest(),

    watchFunPointTokenGetRequest(),
    watchFunPointCardAddRequest(),
    // watchFunPointCardRemoveRequest(),

    watchTapPayCardAddRequest(),
    // watchTapPayCardRemoveRequest(),
]
